import request from 'superagent';

export const bookingMetricSearchEnd = function () {
  const resultElement = document.getElementById('results-metric');

  if (!resultElement) {
    return;
  }

  const guid = resultElement.dataset.guid;
  const partyDetails = resultElement.dataset.partydetails;

  request.post('/umbraco/surface/SearchMetricSurface/SetEndSearch')
    .send({
      guid,
      partyDetails
    }).then().catch(err => {
    console.log(err);
  });
};
